import { type CreateTrackModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<Pick<CreateTrackModel, 'name'>>]: number
} = {
  name: 150,
}
